export const PayloadContentType = {
  COMPLETED: 'Completed',
  FAILED_TO_UPLOAD: 'FailedToUpload',
  SKIPPED: 'Skipped',
};

export const LOAD_PAYLOAD_LABEL = 'Load payload';
